module.exports = __webpack_public_path__ + "static/media/IconePerguntaC.ff6e6c85.svg";